import { graphql } from "@server/gql";

export const deleteUserMutation = graphql(/* GraphQL */ `
  mutation deleteUser($email: String!) {
    deleteUser(email: $email) {
      ...user
    }
  }
`);
